import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const CaseStudies = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const featuredWorks = [
    {
      id: 1,
      category: "PRODUCT DESIGN, SUBSCRIPTION PLATFORM",
      title: "Home Maintenance Subscription Platform",
      description: "Turn home maintenance from something homeowners react to into a relationship they rely on — guided, proactive, and built to grow with them over time.",
      metrics: [
        { value: "Double Digit", label: "SUBSCRIPTION GROWTH" },
        { value: "Measurable", label: "RETENTION LIFT" }
      ],
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
      link: "#"
    },
    {
      id: 2,
      category: "ENTERPRISE UX",
      title: "Making Complexity Disappear",
      description: "Transform Access Management from an outdated portal into a modern, intuitive system that empowers administrators to efficiently manage users across Allegion's growing application portfolio.",
      metrics: [
        { value: "↓TIME TO MANAGE USERS", label: "" },
        { value: "↑VISIBILITY INTO USER BASE", label: "" }
      ],
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
      link: "#"
    },
    {
      id: 3,
      category: "PRODUCT DESIGN, LOYALTY, WORKSHOPS, BADGES",
      title: "Turning In-Store Badges Into a Digital Engagement Layer",
      description: "Transform a beloved in-store tradition into a scalable digital engagement platform — giving every participant a personal profile, every badge a digital home, and every family a reason to keep coming back.",
      metrics: [
        { value: "Rapid", label: "FIRST-WEEK ADOPTION" },
        { value: "High", label: "REGISTRATION RATE" }
      ],
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
      link: "#"
    }
  ];

  return (
    <>
      <section className="section case-studies-section">
        <div className="container">
          <motion.div
            className="row"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={containerVariants}
            ref={ref}
          >
            <div className="col-md-12">
              <motion.div className="heading-title" variants={itemVariants}>
                <h1>Featured <span>Work</span></h1>
                <p>Selected projects that showcase my approach to solving complex design challenges and creating meaningful user experiences.</p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            className="featured-works"
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          >
            {featuredWorks.map((work, index) => (
              <motion.div
                key={work.id}
                className="featured-work-item"
                variants={itemVariants}
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="work-content">
                  <div className="work-category">
                    <span>{work.category}</span>
                  </div>
                  <h2 className="work-title">{work.title}</h2>
                  <p className="work-description">{work.description}</p>

                  <div className="work-metrics">
                    {work.metrics.map((metric, idx) => (
                      <div key={idx} className="metric">
                        <div className="metric-value">{metric.value}</div>
                        <div className="metric-label">{metric.label}</div>
                      </div>
                    ))}
                  </div>

                  <motion.a
                    href={work.link}
                    className="view-case-study"
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    View Case Study →
                  </motion.a>
                </div>

                <motion.div
                  className="work-image"
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                >
                  <img src={work.image} alt={work.title} />
                  <div className="image-overlay"></div>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default CaseStudies;
